import React from 'react'
import { useTranslation } from 'react-i18next'

const NumericScoringCard = (_props) => {
  const { t } = useTranslation()
  return (
    <div className='d-flex align-items-center'>
      <div
        style={{
          backgroundColor: '#34ACE0',
          height: 25,
          width: 92,
          borderRadius: 4,
          marginRight: 9,
          color: '#fff',
        }}
        className='d-flex align-items-center justify-content-center'
      >
        <p className='mb-0'>123</p>
      </div>
      <div>
        <p className='mb-0' style={{ lineHeight: 1.2 }}>
          {t('drills.numericScoringCard.numericalScoring')}
        </p>
        <p className='mb-0' style={{ lineHeight: 1.2 }}>
          {t('drills.numericScoringCard.example')}
        </p>
      </div>
    </div>
  )
}

export default NumericScoringCard
